<template>
  <BaseLoader :loader="loader" />

  <div class="admin-container">
    <NaviPanel />

    <main class="main-layout">
      <NaviHeader />

      <div class="content-scroll">
        <div class="cs-card">
            <h3>Dashboard</h3>
            <p class="text-tooltip">Real-time system overview. Monitor live streaming activity and analyze key delivery metrics at a glance.</p>
        
            <button class="spec-btn refresh-btn" @click="dashboard" title="Refresh">
                <app-icon icon="hugeicons:refresh-dot" width="18" />
            </button>
        
        </div>

        <div class="stats-wrapper">
          <div class="cs-card stat-card">
            <span class="stat-label">Active campaigns</span>
            <span class="stat-value">{{ stats.ActiveCampaigns }}</span>
          </div>
          <div class="cs-card stat-card">
            <span class="stat-label">Total Streamers</span>
            <span class="stat-value">{{ stats.TotalStreamers }}</span>
          </div>
          <div class="cs-card stat-card">
            <span class="stat-label">Streamers online</span>
            <span class="stat-value">{{ stats.OnlineStreamers }}</span>
          </div>
          <div class="cs-card stat-card">
            <span class="stat-label">Live Reach</span>
            <span class="stat-value">{{ stats.LiveViewer }}</span>
          </div>          
        </div>

        <div class="chart-wrapper">
          <section class="cs-card card-50">
            <h4>Top Campaigns by Total Views</h4>
            <p class="text-tooltip">Top 5 Campaigns with the highest total views</p>
            <BarChart 
              :chartData="bar1Data" 
              :options="bar1Options"
              :height="240"
            />
          </section>
          <section class="cs-card card-50">
            <h4>Top Campaigns by Target</h4>
            <p class="text-tooltip">Top 5 Campaigns with the highest ratio (target vs total views)</p>
            <BarChart 
              :chartData="bar2Data" 
              :options="bar2Options"
              :height="240"
            />
          </section>  
          
        </div>
        <div class="chart-wrapper">
          <section class="cs-card card-33">
            <h4>Top Formats</h4>
            <p class="text-tooltip">Top Formats by exposure time (seconds)</p>
            <DoughnutChart 
              :chartData="donut1Data" 
              :options="donut1Options"
              :height="240" 
            />
          </section>
          <section class="cs-card card-33">
            <h3>Top Formats</h3>
            <p class="text-tooltip">Top Formats by Views</p>
            <BarChart 
              :chartData="bar3Data" 
              :options="bar3Options"
              :height="240"
            />
          </section>
          <section class="cs-card card-33">
            <h3>Top Streamers</h3>
            <p class="text-tooltip">Top 5 Streamers by Total Views</p>
            
            <table class="table-simple">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Streamer</th>
                  <th>Total Views</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(streamer, index) in stats.TopStreamers" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ streamer.Name }}</td>
                  <td>{{ streamer.Views }}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

      </div>
    </main>
  </div>
</template>


<script>
    import NaviPanel from '@/components/NaviPanel.vue';
    import NaviHeader from '@/components/NaviHeader.vue';
    import BaseLoader from '@/components/BaseLoader.vue';
    
    import shared from "@/shared";
    import apiService from "@/services/other.js";

    import { DoughnutChart } from 'vue-chart-3';
    import { BarChart } from 'vue-chart-3';
    import { Chart, registerables } from "chart.js";

    Chart.register(...registerables);

    export default {
        components: { NaviPanel, NaviHeader, DoughnutChart, BarChart, BaseLoader},
        name: 'HomeView',

        data: function () {
            return {
                error: null,
                loader: true,
                stats: [],
                bar1Options: {
                    responsive: true,
                    maintainAspectRatio: false,                 
                    plugins: {
                    legend: {
                          position: 'bottom',
                          display: false
                    },
                    title: {
                          display: true,
                          text: 'Top 5 Campaigns by Total Views',
                    },
                    },
                    scales: {
                          x: {
                          title: {
                          display: true,
                          text: 'Campaigns'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }
                          },
                          y: {
                          title: {
                          display: true,
                          text: 'No.'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }             
                          }
                    }
                },
                bar2Options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                    legend: {
                          position: 'bottom',
                          display: false
                    },
                    title: {
                          display: true,
                          text: 'Top 5 Campaigns by Target',
                    },
                    },
                    scales: {
                          x: {
                          title: {
                          display: true,
                          text: 'Campaigns'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }
                          },
                          y: {
                          title: {
                          display: true,
                          text: 'No.'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }             
                          }
                    }
                },
                bar3Options: {
                    responsive: true,
                    maintainAspectRatio: false,                 
                    plugins: {
                    legend: {
                          position: 'bottom',
                          display: false
                    },
                    title: {
                          display: true,
                          text: 'Top 5 Formats by Total Views',
                    },
                    },
                    scales: {
                          x: {
                          title: {
                          display: true,
                          text: 'Formats'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }
                          },
                          y: {
                          title: {
                          display: true,
                          text: 'No.'
                          },
                          grid: {
                          color: 'rgba(0, 0, 0, 0.1)'
                          }             
                          }
                    }
                },
                
            };
        },
        
        computed: {
            // Top Campaigns by Total Views - kolumny (Name, Views)
            bar1Data() {
                if (!this.stats.TopCampaignsByTotalViews) return { labels: [], datasets: [] };
                
                // Filtrujemy tylko te, które nie są "-empty-"
                //const validData = this.stats.TopCampaignsByTotalViews.filter(item => item.Name !== '-empty-');
                const validData = this.stats.TopCampaignsByTotalViews;
                
                return {
                    labels: validData.map(item => item.Name),
                    datasets: [
                        {
                            label: 'Views',
                            data: validData.map(item => item.Views),
                            backgroundColor: ['#764ba2'],
                            borderColor: ['#764ba2'],
                            borderRadius: 4
                        }
                    ]
                };
            },
            
            // Top Campaigns by Target - kolumny (Name, Target, Views)
            bar2Data() {
                if (!this.stats.TopCampaignsByTarget) return { labels: [], datasets: [] };
                
                // Filtrujemy tylko te, które nie są "-empty-"
                //const validData = this.stats.TopCampaignsByTarget.filter(item => item.Name !== '-empty-');
                const validData = this.stats.TopCampaignsByTarget;
                
                return {
                    labels: validData.map(item => item.Name),
                    datasets: [
                        {
                            label: 'Target',
                            data: validData.map(item => item.Target),
                            backgroundColor: '#0173bc',
                            borderColor: '#0173bc',
                            borderRadius: 4
                        },
                        {
                            label: 'Views',
                            data: validData.map(item => item.Views),
                            backgroundColor: '#764ba2',
                            borderColor: '#764ba2',
                            borderRadius: 4
                        }
                    ]
                };
            },

            // Top Formats by Views - kolumny (Name, Views)
            bar3Data() {
                if (!this.stats.TopFormats) return { labels: [], datasets: [] };
                
                // Filtrujemy tylko te, które nie są "-empty-"
                //const validData = this.stats.TopFormats.filter(item => item.Name !== '-empty-');
                const validData = this.stats.TopFormats;
                
                return {
                    labels: validData.map(item => item.Name),
                    datasets: [
                        {
                            label: 'Views',
                            data: validData.map(item => item.Views),
                            backgroundColor: ['#0173bc'],
                            borderColor: ['#0173bc'],
                            borderRadius: 4
                        }
                    ]
                };
            },

            filteredStats() {
                if (!this.stats.TopFormatsByExposure) return [];
                return this.stats.TopFormatsByExposure.filter(item => item.Name !== '-empty-');
            },

            donut1Data() {
                return {
                    labels: this.filteredStats.map(item => item.Name),
                    datasets: [{
                        data: this.filteredStats.map(item => item.DurationSec),
                        backgroundColor: ['#77CEFF', '#0173bc', '#764ba2', '#97B0C4', '#A5C8ED', '#1cd4ce'],
                        borderColor: ['#fff']
                  }]
                };
            },

            // Top Formats - wykres kołowy (Name, Views)
            // donut1Data() {
            //     if (!this.stats.TopFormatsByExposure) return { labels: [], datasets: [] };
                
            //     // Filtrujemy tylko te, które nie są "-empty-"
            //     const validData = this.stats.TopFormatsByExposure.filter(item => item.Name !== '-empty-');
                
            //     return {
            //         labels: validData.map(item => item.Name),
            //         datasets: [
            //             {
            //                 data: validData.map(item => item.DurationSec),
            //                 backgroundColor: ['#77CEFF', '#0173bc', '#764ba2', '#97B0C4', '#A5C8ED', '#1cd4ce'],
            //                 borderColor: ['#fff']
            //             }
            //         ]
            //     };
            // },

            donut1Options() {
              return {
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom',
                  },
                  title: {
                    display: true,
                    text: 'Top Formats',
                  },
                  tooltip: {
                    callbacks: {
                      // Tutaj dzieje się magia:
                      label: (context) => {
                        const index = context.dataIndex;
                        const item = this.filteredStats[index];
                        
                        const label = item.Name;
                        const sec = item.DurationSec;
                        const min = item.DurationMin;

                        return ` ${label}: ${sec}s (Czas: ${min})`;
                      }
                    }
                  }
                }
              };
            }
            
           
        },

        created() {           
        },

        mounted() {

            this.dashboard();

        },

        methods: {   
            
            dashboard() {
                this.loader = true;            
                const data = {ResultName: "dashboard"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                      if (response.status === 200) {                  
                              
                              this.stats = response.data;  
                              
                              const arrayKeys = [
                                  "TopCampaignsByTarget",
                                  "TopCampaignsByTotalViews",
                                  "TopStreamers",
                                  "TopFormats",
                                  "TopFormatsByExposure"
                              ];

                              arrayKeys.forEach(key => {
                                  if (this.stats[key]) {
                                      this.stats[key] = shared.fillArrayToFive(this.stats[key]);
                                  }
                              });
                              console.log(this.stats);
                      }
                    })
                    .catch((e) => shared.handleError.call(this, '011', true, e))
                    .finally(() => {
                      this.loader = false;
                    })
                    .finally(() => {
                      this.loader = false;
                    });
            },
                
        },


    }
</script>

<style>
/* 3. LAYOUT GŁÓWNY */
.admin-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

/* MAIN CONTENT */
.main-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}


.content-scroll {
  padding: 40px;
  overflow-y: auto;
}

.stats-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  /* margin-bottom: 40px; */
  justify-content: space-between;
  align-items: center;
}

.stat-card {
    flex: 1;
    background: #fff7ed;
    padding: 16px 20px;

}


.stat-label {
  display: block;
  font-size: 13.6px;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
}

/* Chart wrapper - flexible layout */
.chart-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  /* margin-top: 24px; */
}

.chart-wrapper h4 {
  margin-bottom: 20px;
}

/* Card size classes */
.card-100 {
  flex: 1 1 100%;
}

.card-50 {
  flex: 1 1 calc(50% - 12px);
  min-width: 300px;
}

.card-33 {
  flex: 1 1 calc(33.333% - 16px);
  min-width: 280px;
}

/* Media query - stack all cards on small screens */
@media (max-width: 400px) {
  .card-50,
  .card-33 {
    flex: 1 1 100%;
    min-width: 100%;
  }
}

/* TABLE STYLES */
.table-simple {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 16px;
}

.table-simple thead {
  /* background: linear-gradient(135deg, #764ba2 0%, #667eea 100%); */
  background-color: #f9fafb;
  color: var(--text-main);
}

.table-simple thead tr {
  border-bottom: 1px solid #e5e7eb;
}

.table-simple thead th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-simple thead th:first-child {
  border-radius: 8px 0 0 0;
}

.table-simple thead th:last-child {
  border-radius: 0 8px 0 0;
  text-align: right;
}

.table-simple tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

/* .table-simple tbody tr:last-child {
  border-bottom: none;
} */

.table-simple tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.table-simple tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.table-simple tbody tr:hover {
  background: linear-gradient(90deg, rgba(118, 75, 162, 0.08) 0%, rgba(102, 126, 234, 0.08) 100%);
  transform: translateX(4px);
  box-shadow: -4px 0 0 0 #764ba2;
}

.table-simple tbody td {
  padding: 8px 16px;
  color: #374151;
}

.table-simple tbody td:first-child {
  font-weight: 600;
  color: #764ba2;
  font-size: 16px;
}

.table-simple tbody td:nth-child(2) {
  font-weight: 500;
}

.table-simple tbody td:last-child {
  text-align: right;
  font-weight: 600;
  color: #0173bc;
}


</style>